<template>
    <div>
        <component :is="currentComponent"></component>
    </div>
</template>

<script>
    import ListView from './list'
    import UpdateView from './update'

    const pageComponents = {
        'index': ListView,
        'update': UpdateView,
    };

    export default {
        computed: {
            currentPage() {
                return this.$route.params.action || 'index';
            },
            currentComponent() {
                return pageComponents[this.currentPage];
            },
        },
    }
</script>
